module.exports = __webpack_public_path__ + "static/media/barrel.8442e579.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameOceanCleanup/barrel.png
// module id = 2553
// module chunks = 0